<template>
  <v-row class="mt-12 sign" no-gutters :align="align" :justify="justify">
    <span :class="{'white--text': dark}" class="d-block caption mr-1">con la tecnología de</span>
    <a class="mt-1" href="https://www.piriod.com/" target="_blank">
      <img :src="require(`@/assets/appLogo-color--Onlight${dark ? '-variant' : ''}.svg`)" alt="Piriod brand" height="16">
    </a>
  </v-row>
</template>
<script>
export default {
  props: {
    dark: {
      type: Boolean,
      required: false,
      default: () => (true)
    },
    align: {
      type: String,
      required: false,
      default: () => ('center')
    },
    justify: {
      type: String,
      required: false,
      default: () => ('start')
    }
  }
}
</script>
<style scoped>
.caption,
img {
  opacity: 0.6;
}
</style>